import Vue from 'vue';
import Vuex from 'vuex';
import axios from "axios";
import router from '../router/Router';
import store from '../store/Store';
Vue.use(Vuex);
export const Auth = {
    login(email, password) {
        axios.get("/sanctum/csrf-cookie").then((_) => {
            axios.post('/login', { email: email, password: password }).then((response) => {
                store.commit('user');
            }).finally(() => {
                setTimeout(() => {
                    if (store.getters.userHasRole('Arbeitschritt abschließen')) {
                        router.push("/job/worklogs/");
                    }
                    else {
                        router.push("/dashboard");
                    }
                }, 2500);
            });
        });
    },
    logout() {
        axios.get("/sanctum/csrf-cookie").then((_) => {
            axios.post('/logout').then((response) => {
                store.state.user = null;
            }).finally(() => {
                router.push('/login');
            });
        });
    },
    user() {
        axios.get('/api/user').then((response) => {
            if (response.status === 200) {
                store.state.user = response.data.data;
            }
            else {
                store.state.user = null;
            }
        }).catch((error) => {
            if (error.response.status != 200) {
                this.logout();
            }
        });
    }
};
export default Auth;
